// extracted by mini-css-extract-plugin
export var deleteModal = "_ie-0";